<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">
    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.start' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="startYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.end' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="endYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item" *ngIf="allListFilter">
      <mat-label>{{'country.kf-registration.table.key-figures' |translate}}</mat-label>
      <input matInput type="text" [formControl]="keyFiguresControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'country.kf-registration.table.b2b/b2c' |translate}}</mat-label>
      <mat-select [formControl]="b2bb2cControl">
        <mat-option value="UNDIFFERENTIATED"> Undifferentiated </mat-option>
        <mat-option value="DIFFERENTIATED"> Differentiated </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'country.kf-registration.table.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value=""> - </mat-option>
        <mat-option value="validated"> Validated </mat-option>
        <mat-option value="completed"> Completed </mat-option>
        <mat-option value="incomplete"> Incomplete </mat-option>
        <mat-option value="confidential"> Confidential </mat-option>
        <mat-option value="not able to validate"> Not able to validate </mat-option>
        <mat-option value="not started"> Not started </mat-option>
      </mat-select>
    </mat-form-field>


    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>

  </form>
</div>
